export const GET_SETTINGS = 'GET_SETTINGS';
export const GET_SETTING_BY_ID = 'GET_SETTING_BY_ID';
export const UPDATE_SETTING = 'UPDATE_SETTING';
export const DELETE_SETTING = 'DELETE_SETTING';
export const CREATE_SETTING = 'CREATE_SETTING';
